module.exports = __webpack_public_path__ + "static/ModernEra-Bold-6ff578ffd31d772508b83b1d4e4f8fe6.eot";